<section [class.mobile]="isMobile()">
  <ng-content></ng-content>
  @if (!hasSendPWForgotMail()) {
    <div class="change-password-container">
      <h1 class="head">{{ i18n.langString("forgot_password_title") }}</h1>
      <div class="email-text">
        <span class="email-span">{{
          i18n.langString("forgot_password_text")
        }}</span>
      </div>
      <app-common-form
        [formConfigureInput]="formConfiguration"
        [submitText]="'Send Email'"
        (formSubmit)="forgetPassword($event)"
        [isAdmin]="false"
        [formType]="'forgetPassword'"
        [captchaEnabled]="cfg.enableCaptcha"
      ></app-common-form>
    </div>
  }
  @if (hasSendPWForgotMail()) {
    <div class="mail-content">
      <h1>{{ i18n.langString("check_your_email") }}</h1>
      <p>
        {{ i18n.langString("check_your_email_generic") }}
      </p>
      <div class="specific-buttonwrapper">
        <app-nav-button
          [darksecondary]="true"
          svgIcon="icons:installation_agent"
          (clickEvent)="PWForgotMailNotReceived()"
          >{{ i18n.langString("email_not_received") }}
        </app-nav-button>
      </div>
    </div>
  }
</section>
